import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { datadogRum } from '@datadog/browser-rum';
import { persistState } from '@datorama/akita';
import { defineCustomElements } from 'epi-components/loader';

import packageJson from '../package.json';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const version = packageJson.version;

/** State management persistance */
const persist = persistState({
	key: environment.akitaPersistKey,
	storage: sessionStorage,
});
const providers = [{ provide: 'persistStorage', useValue: persist }];
if (environment.production) {
	enableProdMode();

	datadogRum.init({
		applicationId: environment.datadog.applicationId,
		clientToken: environment.datadog.clientToken,
		site: 'us3.datadoghq.com',
		service: 'quote-engine-v3',
		env: environment.datadog.env,
		sessionSampleRate: 100,
		sessionReplaySampleRate: 20,
		trackUserInteractions: true,
		trackResources: true,
		trackLongTasks: true,
		defaultPrivacyLevel: 'mask-user-input',
		allowedTracingUrls: [
			/https:\/\/.*\.embracepetinsurance\.com/,
			'https://epiquoteengineorchestrator-p.azurewebsites.net'
		],
		trackSessionAcrossSubdomains: true,
		enablePrivacyForActionName: true,
		actionNameAttribute: 'data-quat',
		version,
		// @ts-expect-error: this is a valid option
		beforeSend: (event, context) => {
			if (event?.type === 'action' && event?.action && event?.action?.target) {
				// @ts-expect-error: this is the correct object
				const targetClassList = Array.from(context?.events && context?.events[0] && context?.events[0]?.target?.classList) || [];
				// we want to hide any address information in the session replay that
				// originates from the Google autocomplete element
				// this isn't perfect, but it gets most of the important information so
				// we can't see a full address, only parts
				if (targetClassList?.some(className => (className as string).includes('pac-'))){
					event.action.target.name = '[ADDRESS REDACTED]';
				}
			}

			return event;
		}
	});
}

platformBrowserDynamic(providers)
	.bootstrapModule(AppModule)
	.catch(err => console.error(err));

/** instantiate to use */
void defineCustomElements(
	window,
	/**
	 * Used in conjunction with the component library's `getAssetPath` method. We may want to set up a way to use this
	 * in a way that is less icon focused so that we can use more assets with the component lib
	 *
	 * @prop {string}resourcesUrl
	 */
	{ resourcesUrl: 'assets/icons/' }
);
